import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Avatar,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { getUser } from '../services/authService';
import React, { useState } from "react";

const Header = ({ collapsed }) => {
  const drawerWidth = 240;
  const collapsedWidth = 70;

  const [showUserInfo, setShowUserInfo] = useState(false);

  const handleAvatarClick = () => {
    setShowUserInfo(!showUserInfo);
  };

  // Get user data from localStorage
  const user = getUser();

  // Role mapping
  const getRoleName = (roleId) => {
    switch (roleId) {
      case 1: return 'Tenant Admin';
      case 2: return 'Super Admin';
      default: return 'Admin';
    }
  };

  // ✅ NEW: Capitalize each word — handles "bhavika hotwani" → "Bhavika Hotwani"
  const capitalizeName = (name) => {
    if (!name) return '';
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Get user display data — names always properly capitalized
  const firstName = user ? capitalizeName(user.firstName) : 'User';
  const lastName  = user ? capitalizeName(user.lastName)  : '';
  const userName  = `${firstName} ${lastName}`.trim();
  const userRole  = user ? getRoleName(user.roleId) : 'Admin';
  const userInitial = firstName.charAt(0).toUpperCase();


  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${collapsed ? collapsedWidth : drawerWidth}px)`,
        ml: `${collapsed ? collapsedWidth : drawerWidth}px`,
        bgcolor: 'white',
        color: 'black',
        transition: 'all 0.3s ease-in-out',
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        minHeight: 56,
        px: 2
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* Notification Icon */}
          <IconButton
            sx={{
              color: '#070606ff',
              ml: 5,
              '&:hover': { backgroundColor: '#f5f5f5' }
            }}
          >
            <NotificationsActiveIcon sx={{ fontSize: 21 }} />
          </IconButton>

          {/* User Profile */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer',
              p: 1,
              borderRadius: 2,
              transition: 'all 0.2s ease',
            }}
            onClick={handleAvatarClick}
          >
            <Avatar
              sx={{
                bgcolor: '#5ABA85',
                width: 36,
                height: 36,
                fontSize: '16px',
                fontWeight: 600,
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.1)',
                  boxShadow: '0 4px 12px rgba(90, 186, 133, 0.4)',
                  cursor: 'pointer'
                }
              }}
            >
              {userInitial}
            </Avatar>

            {/* User Info with smooth transition */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: showUserInfo ? 120 : 0,
                opacity: showUserInfo ? 1 : 0,
                transition: 'all 0.3s ease-in-out',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                {userName}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1 }}>
                {userRole}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;